(function (Cobalt) {
    var $ = jQuery;
    var MobileAdvertising = /** @class */ (function () {
        function MobileAdvertising() {
            this.ResizeTimeout = 0;
            this.ResizeTimeoutDuration = 500;
            this.Thresholds = [1024, 680];
            this.LastWidth = window.innerWidth;
            this.EventHandlers = new MobileAdvertising.EventHandlers(this);
            this.bindEvents();
            this.IsMobileWidth = this.CheckIfThresholdCrossed();
        }
        MobileAdvertising.prototype.bindEvents = function () {
            $(window).on('resize', this.getEventHandler('windowResized'));
        };
        MobileAdvertising.prototype.getEventHandler = function (event) {
            var _this = this;
            if (event && this.EventHandlers[event] !== undefined) {
                return function () {
                    var args = Array.prototype.slice.call(arguments, 0);
                    args.unshift($(this));
                    _this.EventHandlers[event].apply(_this.EventHandlers, args);
                };
            }
        };
        MobileAdvertising.prototype.CheckIfThresholdCrossed = function () {
            var ret = false;
            for (var i = 0; i < this.Thresholds.length; i++) {
                var threshold = this.Thresholds[i];
                ret = ((threshold < this.LastWidth) && (window.innerWidth < threshold)) || ((threshold >= this.LastWidth) && (window.innerWidth > threshold));
                if (ret) {
                    break;
                }
            }
            return ret;
        };
        return MobileAdvertising;
    }());
    Cobalt.MobileAdvertising = MobileAdvertising;
    (function (MobileAdvertising) {
        var EventHandlers = /** @class */ (function () {
            function EventHandlers(ma) {
                this.MobileAdvertising = ma;
            }
            EventHandlers.prototype.windowResized = function () {
                if (this.MobileAdvertising.ResizeTimeout) {
                    clearTimeout(this.MobileAdvertising.ResizeTimeout);
                }
                this.MobileAdvertising.ResizeTimeout = setTimeout(this.MobileAdvertising.getEventHandler('windowResizeTimeoutFired'), this.MobileAdvertising.ResizeTimeoutDuration);
            };
            EventHandlers.prototype.windowResizeTimeoutFired = function () {
                if (this.MobileAdvertising.CheckIfThresholdCrossed()) {
                    if (window.cdmRemoveAds) {
                        window.cdmRemoveAds();
                    }
                }
                this.MobileAdvertising.LastWidth = window.innerWidth;
            };
            return EventHandlers;
        }());
        MobileAdvertising.EventHandlers = EventHandlers;
    })(MobileAdvertising = Cobalt.MobileAdvertising || (Cobalt.MobileAdvertising = {}));
})(Cobalt || (window.Cobalt = {}));
$(function () {
    if ($('body').hasClass('responsive-enabled')) {
        new Cobalt.MobileAdvertising();
    }
});


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.MobileAdvertising.js